import { sassmallRequest } from "./client";

export interface SassmallCartItemAddRequest {
  rawUrl: string;
  normalizedUrl?: string;
  platform: string;
  shopId?: string;
  shopName?: string;
  itemId: string;
  skuId?: string;
  skuText?: string;
  quantity: number;
  title: string;
  imageUrl: string;
  priceSnapshot: number;
  currency?: string;
  purchaseModeHint?: string;
  supportApiPurchase?: boolean;
  userRemark?: string;
  categoryId?: number | string;
  categoryName?: string;
  snapshotJson?: string;
  [key: string]: any;
}

/** 再来一单由后端读取订单明细并重新计价，不能提交历史售价。 */
export interface SassmallCartRepurchaseRequest {
  sourceSaleOrderItemId: string;
  quantity: number;
}

export function pageSassmallCartItems(payload = { pageNo: 1, pageSize: 2000 }) {
  return sassmallRequest<Record<string, any>>("/cart/items/page", {
    method: "POST",
    body: payload,
  });
}

export function addSassmallCartItem(payload: SassmallCartItemAddRequest | SassmallCartRepurchaseRequest) {
  return sassmallRequest<Record<string, any>>("/cart/items", { method: "POST", body: payload });
}

export function updateSassmallCartItemQuantity(payload: { id: string; quantity: number }) {
  return sassmallRequest<Record<string, any>>("/cart/items/quantity", { method: "POST", body: payload });
}

export function updateSassmallCartItemRemark(payload: { id: string; userRemark?: string }) {
  return sassmallRequest<Record<string, any>>("/cart/items/remark", { method: "POST", body: payload });
}

export function updateSassmallCartItemSelection(payload: { ids: string[]; selected: boolean }) {
  return sassmallRequest("/cart/items/selection", { method: "POST", body: payload });
}

export function deleteSassmallCartItem(id: string) {
  return sassmallRequest(`/cart/items/${encodeURIComponent(id)}`, { method: "DELETE" });
}

export function deleteSassmallCartItems(ids: string[]) {
  return sassmallRequest("/cart/items", { method: "DELETE", body: { ids } });
}

export function estimateSassmallCartItems(ids: string[]) {
  return sassmallRequest<Record<string, any>>("/cart/estimate", { method: "POST", body: { ids } });
}

